module.exports = __webpack_public_path__ + "img/couple.d9a86e60.jpg";